class CartItems extends HTMLElement {
  constructor() {
    super();

    this.flagBtnQuantity = false;
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    this.boundUpdateLineItems = this.updateLineItems.bind(this);
    this.handreRender = this.renderContents.bind(this);

  }

  connectedCallback() {
    document.addEventListener('pb:quantity:updated', this.boundUpdateLineItems);
    document.addEventListener('pb:cart:refresh', this.handreRender);
  }

  disconnectedCallback() {
    document.removeEventListener('pb:quantity:updated', this.boundUpdateLineItems);
    document.removeEventListener('pb:cart:refresh', this.handreRender);
  }

  /**
   * Procesa eventos de actualización de cantidad y envía cambios al carrito
   */
  async updateLineItems(event) {
    const { quantity, variantId, lineIndex, productTitle, message } = event.detail;

    try {
      this.lockButtons();

      const body = JSON.stringify({
        line: lineIndex,
        quantity: quantity
      });
      
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body
      });
      
      if (!response.ok) {
        throw new Error(`error cart: ${response.status}`);
      }
      
      window.showToast(`${message}: ${productTitle}`);

    } catch (error) {
      this.unlockButtons();
      console.error(`Error at line ${lineIndex} from cart:`, error);
      window.showToast(`${window.globalTranslations.errorAddToCart}: ${productTitle}`, 'error');
    } finally {
      document.dispatchEvent(new CustomEvent('cart:refresh', {
        detail: {
          variantId
        }
      }));
    }
  }

  // Bloquea botones del drawer para evitar múltiples peticiones mientras se actualiza el cart
  lockButtons() {
    document.querySelector('#CartDrawer-Form')?.classList.add('in-request')
    this.querySelectorAll('button').forEach(button => {
      button.setAttribute('disabled', 'disabled');
      button.classList.add('disabled');
    });
  }

  
  // Desbloqueo manual de botones solo en caso de error
  // (después de una petición correcta el drawer se vuelve a renderizar y se desbloquea solo)
  unlockButtons() {
    document.querySelector('#CartDrawer-Form')?.classList.remove('in-request')
    this.querySelectorAll('button').forEach(button => {
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
    });
  }



  onChange(event) {
    const previousValue = event.detail?.previousValue || null;
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), previousValue);
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  renderContents() {
  // Obtenemos las secciones que necesitamos actualizar
  const sections = this.getSectionsToRender().map((section) => section.section);
  const sectionsUrl = window.location.pathname;
  
  // Construimos la URL para obtener las secciones actualizadas
  const url = `${sectionsUrl}?sections=${sections.join(',')}`;
  
  // Realizamos la petición para obtener el HTML actualizado
  fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }
      return response.json();
    })
    .then((sections) => {
      // Actualizamos cada sección con el HTML recibido
      this.getSectionsToRender().forEach((section => {
        const elementToReplace =
          document.getElementById(section.id)?.querySelector(section.selector) || 
          document.getElementById(section.id);
        
        if (elementToReplace && sections[section.section]) {
          // Usamos DOMParser para extraer solo el contenido relevante
          const parser = new DOMParser();
          const doc = parser.parseFromString(sections[section.section], 'text/html');
          
          // Buscamos el mismo elemento en el HTML recibido
          const newContent = doc.getElementById(section.id);
          
          if (newContent) {
            // Si encontramos el elemento, reemplazamos solo su contenido interno
            elementToReplace.innerHTML = newContent.innerHTML;
          } else {
            // Si no encontramos el elemento exacto, buscamos el selector dentro del HTML
            const selectorContent = doc.querySelector(section.selector);
            if (selectorContent) {
              elementToReplace.innerHTML = selectorContent.innerHTML;
            } else {
              // Si no encontramos ni el ID ni el selector, usamos todo el contenido
              // pero solo para elementos que esperamos que sean contenedores
              console.log(`No se encontró el elemento con ID ${section.id} o selector ${section.selector} en la respuesta`);
              elementToReplace.innerHTML = sections[section.section];
            }
          }
        }
      }));
      
      // Actualizamos el contador de items en el carrito
      //this.updateLiveRegions();
    })
    .catch((error) => {
      console.error('Error al renderizar contenido:', error);
    });
}

  updateQuantityOnProduct(variantId) {
    console.log('updateQuantityOnProduct')
    /* $(`#list-cart [data-id="${variantId}"]`).remove();
    $(`.product-description[data-id="${variantId}"]`).find('.list-quantity-inside-product').addClass('hidden');
    $(`.product-description[data-id="${variantId}"]`).find('.product-button-add-cart').show();

    if (window.innerWidth < 500) {
      $(`.product-description[data-id="${variantId}"]`).find('.reviews-area').show();
    } */
  }

  updateQuantity(line, quantity, name, previousValue) {
    console.log('updateQuantity')
   /*  const variantId = this.querySelector('button').dataset.variantId;
    const productId = this.querySelector('button').dataset.productId;

    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        if(parsedState.errors) {
          throw parsedState.errors;
        }

        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
          document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);

          if(elementToReplace){
            elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }));

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);

        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }

        this.disableLoading();

        if(quantity == 0) {
          this.updateQuantityOnProduct(variantId);
        }

        const modal = document.querySelector('#modal-cards');
        if(modal.classList.contains('is-open')) {
          document.querySelector(`modal-card-opener[data-product-id="${productId}"]`).dispatchEvent(new CustomEvent('modal:updated'));
        }

        const cart = document.querySelector('cart-drawer');
        if(cart){
          cart.updateCart();
        }
    
        //REVISADO: ESTE NO LO HEMOS CHEKADO A FONDO PERO SE USA EN LA PAGINA DEL CARRITO APRA LOS ITEMS
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        setTimeout(() => {
          this.flagBtnQuantity = false;
        }, 1000);

      }).catch((error) => {
        console.error(error);
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = error;

        // Restaurar el valor previo en el input si está disponible
        if (previousValue !== null) {
          const inputElement = document.getElementById(`CartItem-${line}`)?.querySelector('input') || 
            document.getElementById(`CartDrawer-Item-${line}`)?.querySelector('input');
          
          if (inputElement) {
            inputElement.value = previousValue;
          }
        }
        
        setTimeout(() => {
          errors.textContent = '';
        }, 5000);

        this.disableLoading();
        
        
      }).finally(() => {
        setTimeout(() => {
          this.populateQuantity();
          //REVISADO: ESTE NO LO HEMOS CHEKADO A FONDO PERO SE USA EN EL CART ITEMS DE LA PAGINA DEL CARRITO
          document.dispatchEvent(new CustomEvent('cart:refresh'));
      }, 500);
    }); */
  }

  /* old function */
  populateQuantity() {
    console.log('populate qunatity old')
    /* var items = JSON.parse(localStorage.getItem('current-cart')) || [];

    items.forEach(item => {
      const hasDiscount = parseFloat(item.discounts[0]?.amount) > 0 ? true : false;
      const variantId = item.id;
      this.updateProductCardPrice(variantId, item.final_price, hasDiscount)    
    })

    if (items.length) {
      for (var i = 0; i < items.length; i++) {
        var product = $(`.product-description[data-id="${items[i].id}"]`);

        if (window.innerWidth < 500) {
          $(product).find('.reviews-area').hide();
        }

        $(product).find('.list-quantity-inside-product').removeClass('hidden');
        $(product).find('.product-button-add-cart').hide();

        $(product).find('.list-quantity-inside-product h4').text(items[i].quantity);
      }
    } */
  }

  /* old function */
  updateProductCardPrice(variantId, finalPrice, hasDiscount = false) {
    console.log('update cart price')
    /* const cardProduct = document.querySelector(`.product-description[data-id="${variantId}"]`);
    if (!cardProduct) return;
  
    const priceBoxPrivate = cardProduct.querySelector('.c-cp__price__pricebox[data-private-event]');
    const priceBoxBusiness = cardProduct.querySelector('.c-cp__price__pricebox[data-business-event]');
    const pricePerUnitPrivate = cardProduct.querySelector('.c-cp__price__perunit__t[data-private-event]');
    const pricePerUnitBusiness = cardProduct.querySelector('.c-cp__price__perunit__t[data-business-event]');
    const pricePerType = cardProduct.querySelector('price-per-type');
    const priceMain = cardProduct.querySelector('[data-event-main-price]');
  
    if (priceBoxPrivate) {
      const unitPerTypeAttr = parseFloat(priceBoxPrivate.getAttribute('data-unit-per-type'));
      const ivaAttr = priceBoxPrivate.getAttribute('data-iva');

      const iva = parseFloat(ivaAttr);
      const priceEl = priceBoxPrivate.querySelector('.c-cp__price__pricebox__price');
      const priceWithIva = parseFloat(finalPrice) * (1 + iva / 100);
  
      if (priceEl && !isNaN(iva)) {
        const priceWithUnit = priceWithIva / unitPerTypeAttr;

        if(!priceBoxPrivate.classList.contains('c-cp__price__pricebox--sale')){
          priceEl.closest('.c-cp__price__pricebox').style.color = hasDiscount ? '#f44336' : '#000';
        }
        priceEl.textContent = `${Shopify.formatMoney(priceWithIva, "{{amount}}€")}`;

        if (pricePerUnitPrivate) {
          pricePerUnitPrivate.style.color = hasDiscount ? '#f44336' : '#000';
          if(priceMain && priceMain.classList.contains('hidden')){
            pricePerUnitPrivate.textContent = `${Shopify.formatMoney(priceWithUnit, "{{amount}}€")}/Und.`;
          }else{
            pricePerUnitPrivate.textContent = `(${Shopify.formatMoney(priceWithUnit, "{{amount}}€")}/Und.)`;
          }
        }
      }

      if (priceBoxBusiness) {
        const priceEl = priceBoxBusiness.querySelector('.c-cp__price__pricebox__price');
        const priceWithUnit = parseFloat(finalPrice) / unitPerTypeAttr;

        if (priceEl) {

          if(!priceBoxBusiness.classList.contains('c-cp__price__pricebox--sale')){
            priceEl.closest('.c-cp__price__pricebox').style.color = hasDiscount ? '#f44336' : '#000';
          }
            priceEl.textContent = `${Shopify.formatMoney(finalPrice, "{{amount}}€")}`;
        }

        if(pricePerUnitBusiness){
          pricePerUnitBusiness.style.color = hasDiscount ? '#f44336' : '#000';
          if(priceMain && priceMain.classList.contains('hidden')){
            pricePerUnitBusiness.textContent = `${Shopify.formatMoney(priceWithUnit, "{{amount}}€")}/Und.`;
          }else{
            pricePerUnitBusiness.textContent = `(${Shopify.formatMoney(priceWithUnit, "{{amount}}€")}/Und.)`;
          }
        }
        if(pricePerType){
          setTimeout(() => {
            pricePerType.changePriceForType(priceWithIva, finalPrice);
          }, 300);
        }
      }
    } */
  
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

class CartDrawerItems extends CartItems {

  connectedCallback() {}

  disconnectedCallback() {}
  
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__cart-items',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  
}

customElements.define('cart-drawer-items', CartDrawerItems);


if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};
